module.exports = __webpack_public_path__ + "static/media/algar-telecom-logo.3708533c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/algar-telecom-logo.svg
// module id = 2377
// module chunks = 0